import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { getFaviconUrl } from "app/services/sitesService/sitesUtils";

import { Favicon } from "../ui/layout/favicon";

const CardContainer = styled.div`
    display: flex;
    padding: 24px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 6px;
    background: linear-gradient(190deg, #fff 17.87%, #d9e1ff 100%);
`;

const DomainContainer = styled.div`
    display: flex;
    padding: 4px 12px 4px 4px;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: ${colorsPalettes.carbon[0]};
`;

export const DomainBanner = (props: { domain?: string; name?: string }) => (
    <CardContainer>
        <DomainContainer>
            <Favicon
                alt=""
                iconUrl={getFaviconUrl(props.domain || "")}
            />
            <Text
                fontVariant="chip1TopRow"
                overflowWrap="anywhere"
            >
                {props.name}
            </Text>
        </DomainContainer>
    </CardContainer>
);
